import { useEffect, useState, useRef } from "react";
import { useSearchParams,useLocation, useNavigate } from "react-router-dom";
import { Col, Row, Grid } from "antd";
import { MySegmented, MyText, MyButton } from "../../components";
import { ButtonContainer, ScrollableCol } from './style';
import { LeftOutlined } from "@ant-design/icons";
import { OurChildrens } from './OurChildrens';
import { Games } from './Games';
import { MultimediaLibrary } from './MultimediaLibrary';
import { Firework } from './Firework';
import Card from "antd/es/card/Card";
import { AudioModal } from './popups/AudioPopup';
import {useTranslation} from "react-i18next";
import { useLang } from "../../utils/context/lang";
import { GamesChapter } from "./GamesChapter";
import { useEmbeddedNavigate } from "../../utils/context/embed";
import { Helmet } from "react-helmet";
import { fetchMaterialsDetailAction, RootState, selectStore } from "../../utils";
import { useDispatch, useSelector } from "react-redux";

const isMobile = window.innerWidth < 768;

export const MaterialsDetailPage = () => {
  const {t} = useTranslation("common")
  const { lang } = useLang();
  
  const [searchParams, setSearchParams] = useSearchParams();
  const id = searchParams.get('id');
  const navigate = useNavigate();
  const embeddedNavigate = useEmbeddedNavigate();
  
  // const [specialistTypes, setSpecialistTypes] = useState([]);
  // const [hasData, setHasData] = useState(false);
  // const [currentId, setCurrentId] = useState<string | null>(null);
  const [content, setContent] = useState<any>(null);
  const [isModalVisible, setIsModalVisible] = useState(false);
  // const [parentName, setParentName] = useState("");
  const [lastPageId, setLastPageId] = useState("");
  const [storedParentPath, setStoredParentPath] = useState('');
  const parentPath = searchParams.get('parentPath');
  const showModal = () => {
    setIsModalVisible(true);
  };
  const {materials: {materialsTree: materialsTreeState, materialsDetail: materialsDetailState}}: RootState = useSelector(selectStore);
  const segmentedParams = searchParams.get('type');
  const typeIdParam = searchParams.get('typeId');
  const dispatch = useDispatch();
  const tree = materialsTreeState?.data?.tree || [];
  const materialsList = materialsTreeState?.data?.materials5List || [];
  const hasData = materialsDetailState?.data?.hasData ?? false;
  const specialistTypes = materialsDetailState?.data?.types ?? [];

  // scenary не уникален (Задания и Зрительная гимнастика оба приходят как "lessons"),
  // поэтому активный таб определяем сначала по typeId, и только потом по scenary/label.
  const currentType =
    (typeIdParam
      ? specialistTypes.find((t: any) => String(t.id) === String(typeIdParam))
      : null)
    ?? (segmentedParams
      ? specialistTypes.find(
          (t: any) =>
            String(t.scenary) === String(segmentedParams) ||
            String(t.label) === String(segmentedParams)
        )
      : null)
    ?? specialistTypes[0]
    ?? null;

  const currentId = currentType?.id ?? null;
  const currentScenary = currentType?.scenary ?? segmentedParams;
  const [parentNameState, setParentNameState] = useState("");

  // const parentName = materialsDetailState?.data?.name ?? "";
  const materialId = searchParams.get("id")
  const age = searchParams.get("age")
  const parent = searchParams.get("parentId")
  const parentTheme = searchParams.get('parentTheme');
  const isSingle = searchParams.get('single');
  const [materials, setMaterials] = useState<any[]>([]);
  // const [materialsList, setMaterialsList] = useState<any[]>([]);
  const { useBreakpoint } = Grid;
  const screens = useBreakpoint();

    useEffect(() => {
      if (id) {
        const safeSegmentedParams = (!segmentedParams || segmentedParams === 'undefined') 
          ? null 
          : segmentedParams;
        dispatch(fetchMaterialsDetailAction({ id, segmentedParams: safeSegmentedParams }));
      }
    }, [id, segmentedParams]);

  useEffect(() => {
    if (materialsDetailState?.data?.name) {
      setParentNameState(materialsDetailState.data.name);
    }
  }, [materialsDetailState?.data?.name]);

  useEffect(() => {
    const parentId = searchParams.get('parentId');
    const age = searchParams.get('age');
    const type = searchParams.get('type');

    const earlyAgeRanges = ['0-1', '0-2', '1-2'];
    let parentPath;

    if (earlyAgeRanges.includes(age)) {
        parentPath = 'early';
    } else {
        parentPath = 'preschool';
    }

    if (parentPath) {
        const updatedParentPath = `/materials/${parentPath}?id=${parentId}&type=${age}`;
        setStoredParentPath(updatedParentPath);
    }
}, [searchParams, lastPageId]);

const scrollableRef = useRef<HTMLDivElement | null>(null);

  const handleOk = () => {
    setIsModalVisible(false);
  };

  const handleCancel = () => {
    setIsModalVisible(false);
  };

  const handleClick = () => {
    const materialExists = materialsList.some(item => item.id == materialId);
  
    if (materialExists) {
      if (parentTheme) {
        const updatedParentPath = `/materials/detail/?id=${materialId}&type=lessons`;
        embeddedNavigate(updatedParentPath);
    } else {
      embeddedNavigate('/');
    }
    } else {
      if (parentTheme && !isSingle) {
        const updatedParentPath = `/materials/detail/?id=${materialId}&age=${age}&parentId=${parent}&type=lessons`;
        embeddedNavigate(updatedParentPath);
      } else {
        embeddedNavigate(storedParentPath);
      }
    }
  };
  
  useEffect(() => {
    if (scrollableRef.current) {
      const activeElement = scrollableRef.current.querySelector('.ant-segmented-item-selected');
      if (activeElement) {
        activeElement.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
      }
    }
  }, [currentId]);

  const handleChangeSegmented = (id: number) => {
    const selectedType = specialistTypes.find(type => String(type.id) === String(id));
    if (selectedType) {
      // typeId обязателен: у нескольких табов может быть одинаковый scenary.
      handleSetSearchParams({
        type: selectedType.scenary,
        typeId: selectedType.id,
      });
    }
  };


const handleSetSearchParams = (params: Record<string, any>) => {
  setSearchParams(prevParams => {
    const newParams = new URLSearchParams(prevParams.toString())
    Object.entries(params).forEach(([key, value]) => {
      if (value === undefined || value === null || value === '') {
        newParams.delete(key);
      } else {
        newParams.set(key, String(value));
      }
    });
    if (newParams.has('parentId')) {
      setLastPageId(newParams.get('parentId'));
    }
    return newParams;
  });
};

// Держим URL в соответствии с активным табом: дописываем typeId и чиним type,
// если он пришёл пустым, как label, или остался от другого материала.
useEffect(() => {
  if (!currentType) return;

  const patch: Record<string, any> = {};

  if (currentType.scenary && segmentedParams !== currentType.scenary) {
    patch.type = currentType.scenary;
  }
  if (currentType.id != null && String(typeIdParam ?? '') !== String(currentType.id)) {
    patch.typeId = currentType.id;
  }

  if (Object.keys(patch).length) {
    handleSetSearchParams(patch);
  }
}, [currentType?.id, currentType?.scenary, segmentedParams, typeIdParam]);


  const renderContent = () => {
    if (!hasData) {
      return (
        <Card>
          <MyText color='rgba(89, 89, 90, 1)' size={24} weight={600} style={{ fontFamily: 'Nunito', marginLeft: '60px' }}>
            {t("scenarios")}
          </MyText>
        </Card>
      );
    }

    switch (currentScenary) {
      case 'lessons':
        if (parentTheme) {
          return currentId ? <Games id={currentId} /> : null;
        }
        return currentId ? <GamesChapter id={currentId} /> : null;
      case 'multimedia':
        return currentId ? <MultimediaLibrary id={currentId} /> : null;
      case 'ideas':
        return currentId ? <Firework id={currentId} /> : null;
        case 'content':
        return currentId ? <OurChildrens id={currentId} /> : null;
    }
  };

  return (
    <>
   <Helmet>
  {Number(materialId) == 185 ? (
    <>
      <title>Задержка психического развития у детей – помощь и рекомендации</title>
      <meta
        name="description"
        content="Материалы для родителей и педагогов по поддержке детей с ЗПР: игры, упражнения, советы специалистов."
      />
      <meta
        name="keywords"
        content="дети с ООП, ЗПР"
      />
    </>
  ) : Number(materialId) == 182 ? (
    <>
      <title>Нарушение речи у детей – коррекция и развитие</title>
      <meta
        name="description"
        content="Упражнения и советы логопедов для детей с нарушением речи. Эффективные методы для развития правильной речи."
      />
      <meta
        name="keywords"
        content="дети с ООП, нарушение речи"
      />
    </>
  ) : Number(materialId) == 184 ? (
    <>
      <title>Поддержка детей с нарушением зрения – методики и игры</title>
      <meta
        name="description"
        content="Советы и упражнения для развития детей с нарушением зрения. Рекомендации для родителей и педагогов."
      />
      <meta
        name="keywords"
        content="дети с ООП, нарушение зрения"
      />
    </>
  ) : (
    <>
      <title>
        Развитие детей раннего и дошкольного возраста – задания, игры, мультфильмы, советы родителям и педагогам
      </title>
      <meta
        name="description"
        content="Задания, упражнения, игры, мультфильмы и методики для развития детей от раннего и дошкольного возраста. Полезные статьи и советы для родителей и педагогов: развитие речи, мышления, внимания и подготовка к школе."
      />
      <meta
        name="keywords"
        content="развитие ребёнка, ранний возраст, дошкольное обучение, развивающие игры, упражнения для детей, логика, математика, внимание, подготовка к школе, помощь родителям, методический материал для воспитателей, детский сад онлайн"
      />
    </>
  )}
</Helmet>

    <Row justify='center'>
    <Col span={20}>

      <AudioModal visible={isModalVisible} onOk={handleOk} onCancel={handleCancel} />

        <Row gutter={[0, 24]}>
          <Col span={24}>
            {/* <div style={{ display: 'flex',gap: isMobile ? '14px' : '24px', alignItems: 'center' }}>
              <ButtonContainer onClick={handleClick}>
                <LeftOutlined style={{ color: 'rgba(10, 3, 60, 0.7)' }} />
              </ButtonContainer>
              <MyText color='#0A033C' size={isMobile ? 22 : 32} weight={800} style={{ fontFamily: 'Nunito', display: 'block' }}>
                {parentName}
              </MyText>
            </div> */}

            <Row align="middle" style={{ height: '60px'}}>
                        {screens.xs ? (
                            <>
                              <Col span={3}>
                                <ButtonContainer onClick={handleClick}>
                                  <LeftOutlined style={{ color: 'rgba(10, 3, 60, 0.7)' }} />
                                </ButtonContainer>
                              </Col>
                              <Col span={21}>
                                <MyText
                                  color="rgba(19, 15, 38, 1)"
                                  size={screens.xs ? 24 : 26}
                                  weight={800}
                                  style={{ fontFamily: 'Nunito', display: 'block', marginLeft: 12 }}
                                >
                                  {parentNameState}
                                </MyText>
                              </Col>
                            </>
                          ) : (
                            <>
                              <ButtonContainer onClick={handleClick}>
                                <LeftOutlined style={{ color: 'rgba(10, 3, 60, 0.7)' }} />
                              </ButtonContainer>
                              <MyText
                                color="rgba(19, 15, 38, 1)"
                                size={32}
                                weight={800}
                                style={{ fontFamily: 'Nunito', display: 'block', marginLeft: 12 }}
                              >
                                {parentNameState}
                              </MyText>
                            </>
                          )}
                      </Row>
          </Col>
          {hasData && (
            <ScrollableCol ref={scrollableRef} span={24}>
              <MySegmented
                type='primary'
                options={specialistTypes}
                onChange={handleChangeSegmented}
                value={currentId}
              />
            </ScrollableCol>
          )}
          <Col span={24}>
          {renderContent()}
          </Col>
            
        </Row>
    </Col>
    </Row>
    </>
  );
};
